/**
 * @generated SignedSource<<99dfb620e7872ca33e72297c2fe085cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SwapAmountFor = "SOURCE" | "TARGET";
export type CreateSwapOfferInput = {
  amount: string;
  amountDefinedFor: SwapAmountFor;
  sourceAssetId: string;
  targetAssetId: string;
};
export type CreateSwapOfferMutation$variables = {
  input?: CreateSwapOfferInput | null | undefined;
};
export type CreateSwapOfferMutation$data = {
  readonly createSwapOffer: {
    readonly __typename: "SwapOffer";
    readonly assetNetConversionRate: PrecisionFloat | null | undefined;
    readonly expiresAt: TimeScalar | null | undefined;
    readonly feeAmount: PrecisionFloat | null | undefined;
    readonly id: string;
    readonly sourceAmount: PrecisionFloat;
    readonly sourceAsset: {
      readonly __typename: string;
      readonly id: string;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
      readonly price: PrecisionFloat | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly targetAmount: PrecisionFloat;
    readonly targetAsset: {
      readonly __typename: string;
      readonly id: string;
      readonly legalUrl: string | null | undefined;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
      readonly price: PrecisionFloat | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly taxAmount: PrecisionFloat;
    readonly warnings: ReadonlyArray<{
      readonly linkMessage: string | null | undefined;
      readonly linkMessageKey: string | null | undefined;
      readonly message: string | null | undefined;
      readonly messageKey: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type CreateSwapOfferMutation = {
  response: CreateSwapOfferMutation$data;
  variables: CreateSwapOfferMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SwapOffer",
    "kind": "LinkedField",
    "name": "createSwapOffer",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sourceAsset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "targetAsset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "legalUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetNetConversionRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "feeAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TradeWarning",
        "kind": "LinkedField",
        "name": "warnings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messageKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkMessageKey",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSwapOfferMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSwapOfferMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "9b3bb189a741cad3202448a4f2aadde0",
    "id": null,
    "metadata": {},
    "name": "CreateSwapOfferMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSwapOfferMutation(\n  $input: CreateSwapOfferInput\n) {\n  createSwapOffer(input: $input) {\n    id\n    __typename\n    expiresAt\n    sourceAsset {\n      __typename\n      id\n      name\n      price\n      logoUrl\n      symbol\n    }\n    targetAsset {\n      __typename\n      id\n      name\n      price\n      logoUrl\n      symbol\n      legalUrl\n    }\n    sourceAmount\n    targetAmount\n    assetNetConversionRate\n    feeAmount\n    taxAmount\n    warnings {\n      message\n      messageKey\n      linkMessage\n      linkMessageKey\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b8cf3f8bc564b6bf09fd992962811e5b";

export default node;
